module.exports = __webpack_public_path__ + "img/wzf_4.d4719f57.png";